export default {
    GET_SELECT_TREASURER:(state)=>{
        return state.selectTreasurer
    },
    GET_RESULT:(state)=>{
        return state.Result
    },
    GET_EDIT_TREASURER:(state)=>{
        return state.editTreasurer
    },
}